module.exports = __webpack_public_path__ + "media/images/icons/SVG/042-44671e275468b1b7475330a36d1e99f7.svg";